var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTime = function SvgIconTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0CB",
    d: "M11.708 10.318a.6.6 0 0 0-.19-.827L8.598 7.668V4.8a.6.6 0 1 0-1.2 0V8a.6.6 0 0 0 .282.509l3.2 2a.6.6 0 0 0 .827-.19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0CB",
    fillRule: "evenodd",
    d: "M8 14.8A6.8 6.8 0 1 1 8 1.2a6.8 6.8 0 0 1 0 13.6m0-1.2A5.6 5.6 0 1 0 8 2.4a5.6 5.6 0 0 0 0 11.2",
    clipRule: "evenodd"
  })));
};
export default SvgIconTime;